module.exports = __webpack_public_path__ + "static/img/TK.41e5cfe3.png";